"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_highlight_1 = __importDefault(require("react-highlight"));
const useClipboardCopy_1 = __importDefault(require("../../hooks/useClipboardCopy"));
const Time_1 = __importDefault(require("../../utils/date/Time"));
const TokenList_1 = __importDefault(require("../../utils/dom/TokenList"));
const variables_1 = require("../../variables");
require("highlight.js/styles/github.css");
require("./Code.css");
exports.default = react_1.default.memo(function Code(_a) {
    var { inline, children, note, copy, value, preview, language } = _a, props = __rest(_a, ["inline", "children", "note", "copy", "value", "preview", "language"]);
    const [copied, state] = (0, useClipboardCopy_1.default)(Time_1.default.Second);
    const handleCopy = (0, react_1.useCallback)(() => {
        var _a;
        state.copy(String((_a = children !== null && children !== void 0 ? children : value) !== null && _a !== void 0 ? _a : ''));
    }, [state.copy, children, value]);
    return (react_1.default.createElement("pre", Object.assign({}, props, { className: TokenList_1.default.join([
            variables_1.StyleNamespace,
            'Code',
            !!note && 'Code--with-note',
            !!copy && 'Code--with-copy',
            !!preview && 'Code--with-preview',
            !inline && 'Code--block',
            inline && 'Code--inline',
            props.className,
        ]) }),
        !inline && note && react_1.default.createElement("div", { className: 'Code__Note' }, note),
        !inline && preview && react_1.default.createElement("div", { className: "Code__Preview" }, preview),
        !language && react_1.default.createElement("pre", null, children !== null && children !== void 0 ? children : value),
        language && (react_1.default.createElement(react_highlight_1.default, { className: language }, children !== null && children !== void 0 ? children : value)),
        !inline && copy && (react_1.default.createElement("div", { className: TokenList_1.default.join(['Code__Copy', !!copied && 'active']), onClick: handleCopy }, copied ? 'copied' : 'copy'))));
});
